


//Modules
import { Box } from "@mui/material"
import { ReactElement } from "react"



const MidBar = ( ) : ReactElement => {
    return (
        <Box sx={{ height : '10vh'}}>

        </Box>
    )
}

export default MidBar